"use client";

import type * as React from "react";
import { useEffect, useState } from "react";
import { VehicleFilterForm } from "@/components/booking/filter/VehicleFilterForm";
import { AppDrawer } from "@/components/ui/app-drawer";
import { Button } from "@/components/ui/button";
import type { VehicleFilters } from "@/lib/vehicles/filters";
import { emptyVehicleFilters } from "@/lib/vehicles/filters";
import { LucideFilter, LucideSlidersHorizontal } from "lucide-react";

type BookingVehicleFilterDrawerProps = {
  appliedFilters: VehicleFilters;
  draftFilters: VehicleFilters;
  onDraftChange: (filters: VehicleFilters) => void;
  onApply: () => void;
  onClear: () => void;
  resultCount: number;
};

export const BookingVehicleFilterDrawer: React.FC<
  BookingVehicleFilterDrawerProps
> = ({
  appliedFilters,
  draftFilters,
  onDraftChange,
  onApply,
  onClear,
  resultCount,
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) {
      onDraftChange(appliedFilters);
    }
  }, [open, appliedFilters, onDraftChange]);

  const handleClear = () => {
    onDraftChange(emptyVehicleFilters);
    onClear();
  };

  const handleApply = () => {
    onApply();
    setOpen(false);
  };

  return (
    <AppDrawer
      direction="right"
      open={open}
      onOpenChange={setOpen}
      headerMode="toolbar"
      title="Filters"
      onClear={handleClear}
      contentClassName="data-[vaul-drawer-direction=right]:w-full data-[vaul-drawer-direction=right]:sm:max-w-2xl"
      trigger={
        <Button variant="secondary" size="xl" className="rounded-full">
          <LucideSlidersHorizontal />
          Filter
        </Button>
      }
      footer={
        <Button
          type="button"
          size="xl"
          // className="h-12 w-full rounded-xl bg-orange-500 text-base font-semibold text-white hover:bg-orange-600"
          onClick={handleApply}
        >
          Show {resultCount} {resultCount === 1 ? "offer" : "offers"}
        </Button>
      }
    >
      <VehicleFilterForm filters={draftFilters} onChange={onDraftChange} />
    </AppDrawer>
  );
};
